import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { mockData } from '../data/mock';

const FAQ = () => {
  const { faqs } = mockData;

  return (
    <section id="faq" className="py-24 md:py-32 px-6 border-t border-ink/5 bg-white/40 backdrop-blur-sm">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-6 text-ink">
            Questions?
          </h2>
          <p className="text-lg md:text-xl text-ink/60 font-medium max-w-2xl mx-auto">
            Everything you need to know about the product and how it works.
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq) => (
            <AccordionItem
              key={faq.id}
              value={`item-${faq.id}`}
              className="bg-white border border-ink/5 rounded-2xl px-6 md:px-8 shadow-saas-sm transition-all hover:shadow-md data-[state=open]:shadow-md data-[state=open]:border-ink/10"
            >
              <AccordionTrigger className="text-lg md:text-xl font-bold hover:no-underline text-left py-6 md:py-8 text-ink group">
                <span className="group-hover:text-lime-hover transition-colors">{faq.question}</span>
              </AccordionTrigger>
              <AccordionContent className="text-base md:text-lg text-ink/70 pb-8 leading-relaxed font-medium">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="mt-16 text-center">
          <div className="inline-flex flex-col items-center p-8 bg-white border border-ink/5 rounded-3xl shadow-saas-sm">
            <p className="font-bold text-ink text-xl mb-3">
              Still have questions?
            </p>
            <p className="text-ink/60 mb-6 font-medium">
              We're here to help you get started.
            </p>
            <a
              href="mailto:hello@governwell.co.uk"
              className="bg-cream hover:bg-lime text-ink rounded-full px-8 py-3 text-base font-bold transition-colors inline-flex items-center gap-2 border border-ink/5 shadow-sm"
            >
              Contact support
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
